import candidateProfile from '@/api/academic/candidate-profile';

import { baseState, baseMutations } from '@/store/mixins';
import { isEmpty, split } from 'lodash';

export const state = {
    ...baseState,
    formViewDatas: []
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    }
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        )
        return candidateProfile.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return candidateProfile.store(data)
    },
    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await candidateProfile.find(id)
            context.commit('SET_EDIT_DATA', response.data)
        }
    },
    update(context, { id, data }) {
        return candidateProfile.update(id, data)
    },
    destroy(context, id) {
        return candidateProfile.destroy(id)
    },
    async getFormViewData(context, { params, index }) {
        let response = await candidateProfile.formModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
    photoUpload(context, data) {
        return candidateProfile.photoUpload(data)
    }
}
